export default __webpack_public_path__ + "static/home_cards_bolivia-5f0420be9746992e64bff453147eddc5.png";